export enum IoEvents {
  changeTo = 'changeTo',
  queueNameReceived = 'queueNameReceived'
}
export type IoEvent = keyof typeof IoEvents

export type EmitPayload<T> = {
  name: IoEvent
  data: T
}

export type ChangeToEmitData = {
  id: string
}
